import React, { useState, useEffect } from 'react';
import { getAllTaskFiles } from "../Services/masterService"
import API_BASE_URL from "../Services/apiConfig";

// Utility function for consistent date/time formatting
const formatDateTime = (dateString, timeOnly = false) => {
    if (!dateString) return 'N/A';

    const options = timeOnly
        ? { hour: '2-digit', minute: '2-digit', hour12: true }
        : { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };

    return new Date(dateString).toLocaleTimeString('en-US', options);
};

// Component Props definition
const TaskViewModal = ({ taskData, onClose, isOpen }) => {
    const [allAttachements, setAttachements] = useState(null)
    const [selectedImage, setSelectedImage] = useState(null);

    console.log('hellloooooo', taskData);
    const fetchCollectionAttachements = async () => {
        const response = await getAllTaskFiles(taskData.id);
        if (response.status == 1) {
            console.log('attachements: ', response)
            setAttachements(response.data.attachments)
        } else {
            console.log('something went wrong!')
            setAttachements([])
        }
    }

    useEffect(() => {
        if (taskData) {
            fetchCollectionAttachements();
        }
    }, [taskData]);

    if (!isOpen || !taskData) return null;
    // Helper function to render a single detail field
    const DetailField = ({ label, value, className = "" }) => (
        <div className={`p-2 border-b border-green-100 ${className}`}>
            <p className="text-xs font-semibold text-green-700 uppercase tracking-wider">{label}</p>
            <p className="text-sm font-medium text-gray-800 break-words">{value || 'N/A'}</p>
        </div>
    );

    // Function to get status badge styling
    const getStatusBadge = (status) => {
        let classes = "inline-block px-3 py-1 text-xs font-bold rounded-full uppercase";
        if (status === "COLLECTED") classes += " bg-green-200 text-green-800";
        else if (status === "NORMAL") classes += " bg-blue-200 text-blue-800";
        else classes += " bg-gray-200 text-gray-800";
        return <span className={classes}>{status}</span>;
    };

    // Deconstruct nested slot data
    const slot = taskData.slot || {};

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl transform transition-all duration-300">

                {/* Modal Header (Green Theme) */}
                <div className="bg-green-600 text-white p-4 flex justify-between items-center rounded-t-xl">
                    <h2 className="text-xl font-bold text-white m-0" >Task Details: #{taskData.id}</h2>
                    <button onClick={onClose} className="text-white hover:text-green-200 text-2xl leading-none">
                        &times;
                    </button>
                </div>

                {/* Modal Body */}
                <div className="p-6 max-h-[80vh] overflow-y-auto">

                    {/* Status and Priority */}
                    <div className="flex justify-between mb-4 pb-4 border-b border-green-200">
                        <div className="p-2 border-b border-green-100 border-none">
                            <p className="text-xs font-semibold text-green-700 uppercase tracking-wider">Status</p>
                            {getStatusBadge(taskData.status)}
                        </div>

                        {taskData.taskType === "Sample Pickup Request" ? (
                            <DetailField label="Task Type" value="Pickup Request" className="border-none" />
                        ) : (
                            <DetailField label="Task Type" value={taskData.taskType} className="border-none" />
                        )}

                        <DetailField label="Priority" value={taskData.priority} className="border-none" />
                    </div>


                    {/* General Details */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-2 mb-6">
                        <DetailField
                            label="Preferred Date"
                            value={new Date(taskData.preferredDate)
                                .toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
                                .replace(/\//g, '-')}
                        />

                        <DetailField
                            label="Time Slot"
                            value={`${slot.startTime.slice(0, 5)} - ${slot.endTime.slice(0, 5)}`}
                        />

                        <DetailField label="Assigned To" value={taskData?.assignedUser?.employeeName || "Pending"} />
                        <DetailField label="Created By" value={`${taskData.createdBy}`} />
                        <DetailField label="Created At" value={formatDateTime(taskData.createdAt)} />
                        <DetailField label="Last Updated" value={formatDateTime(taskData.updatedAt)} />
                        <DetailField label="Accepted" value={formatDateTime(taskData.acceptedAt)} />
                        <DetailField label="Start" value={formatDateTime(taskData.startedAt)} />
                        <DetailField label="Collected" value={formatDateTime(taskData.collectedAt)} />
                        <DetailField label="Handover" value={formatDateTime(taskData.handoveredAt)} />
                    </div>

                    {/* Pickup Details Section (The Source) */}
                    <h3 className="text-lg font-bold text-green-600 border-b border-green-300 pb-2 mb-4 mt-4">
                        Pickup Location (Source)
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2 mb-6">
                        <DetailField label="Client " value={taskData?.pickupClient?.clientName} />
                        <DetailField label="Address" value={taskData.pickupAddress} />
                        <DetailField label="Latitude" value={taskData.pickupLatitude} />
                        <DetailField label="Longitude" value={taskData.pickupLongitude} />
                        <DetailField label="Address" value={taskData?.pickupClient?.area} />
                    </div>

                    {/* Drop Details Section (The Destination) */}
                    <h3 className="text-lg font-bold text-green-600 border-b border-green-300 pb-2 mb-4">
                        Drop Location (Destination)
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2 mb-6">
                        <DetailField label="Drop Centre" value={taskData?.dropCentre?.centreName} />
                        <DetailField label="Address" value={taskData.dropAddress} />
                        <DetailField label="Latitude" value={taskData.dropLatitude} />
                        <DetailField label="Longitude" value={taskData.dropLongitude} />
                        <DetailField label="Address" value={taskData?.dropCentre?.address} />
                    </div>
                    {!['ASSIGNED', 'ACCEPTED', 'IN_PROGRESS'].includes(taskData.status) && (
                        <>
                            <h3 className="text-lg font-bold text-green-600 border-b border-green-300 pb-2 mb-4 mt-4">
                                Collection Attachments
                            </h3>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                                {allAttachements && allAttachements.length > 0 ? (
                                    allAttachements.map((attachment) => (
                                        <div
                                            key={attachment.id}
                                            className="border border-gray-200 rounded-lg overflow-hidden cursor-pointer"
                                            onClick={() => setSelectedImage(API_BASE_URL + '/' + attachment.filePath)}
                                        >
                                            <img
                                                src={API_BASE_URL + '/' + attachment.filePath}
                                                alt={`Attachment ${attachment.id}`}
                                                className="w-full h-32 object-cover"
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <p className="text-gray-500 col-span-full">No attachments available for this task.</p>
                                )}
                            </div>

                            {/* Fullscreen Image Modal */}
                            {selectedImage && (
                                <div
                                    className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
                                >
                                    {/* Close Button */}
                                    <button
                                        onClick={() => setSelectedImage(null)}
                                        className="absolute top-4 right-4 text-white text-2xl font-bold z-50 hover:text-gray-300"
                                    >
                                        &times;
                                    </button>

                                    {/* Image */}
                                    <img
                                        src={selectedImage}
                                        alt="Preview"
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                            )}
                        </>
                    )}

                    {/* Description */}
                    <h3 className="text-lg font-bold text-green-600 border-b border-green-300 pb-2 mb-4">
                        Notes / Description
                    </h3>
                    <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                        <p className="text-sm text-gray-700 italic">{taskData.description || 'No description provided.'}</p>
                    </div>

                </div>

                {/* Modal Footer */}
                <div className="p-4 bg-gray-50 flex justify-end rounded-b-xl">
                    <button
                        onClick={onClose}
                        className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition duration-150"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TaskViewModal;